(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[30671,65250],{

/***/ 30671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ GoAutoWarrantyWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/shared/header/index.tsx
var header = __webpack_require__(74206);
// EXTERNAL MODULE: ./src/hooks/useModalContext.tsx
var useModalContext = __webpack_require__(67379);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
;// CONCATENATED MODULE: ./src/components/goautowarranty/logo/index.tsx


function GoAutoWarrantyLogo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "306",
        height: "35",
        fill: "none",
        viewBox: "0 0 306 35",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1_265)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#00445F",
                        d: "M11.774 17.823v-3.984h10.243v9.381c-.994.963-2.438 1.812-4.33 2.546a15.79 15.79 0 01-5.735 1.111c-2.462 0-4.609-.517-6.442-1.55a9.872 9.872 0 01-4.128-4.439A14.35 14.35 0 010 14.617c0-2.45.514-4.63 1.541-6.538a10.41 10.41 0 014.515-4.386c1.51-.785 3.389-1.177 5.638-1.177 2.923 0 5.206.613 6.85 1.84 1.644 1.225 2.702 2.919 3.173 5.08l-4.722.89a4.978 4.978 0 00-1.87-2.74c-.915-.668-2.058-1.003-3.431-1.004-2.079 0-3.73.658-4.955 1.975-1.224 1.317-1.837 3.274-1.839 5.871 0 2.796.62 4.893 1.862 6.29 1.242 1.398 2.87 2.098 4.884 2.098a8.19 8.19 0 002.996-.59c.924-.35 1.792-.833 2.577-1.432v-2.971h-5.445zM25.332 17.701a9.227 9.227 0 011.109-4.355 7.583 7.583 0 013.145-3.212 9.323 9.323 0 014.54-1.107c2.579 0 4.694.839 6.345 2.516 1.65 1.677 2.475 3.795 2.472 6.351 0 2.58-.833 4.719-2.498 6.419-1.664 1.7-3.761 2.548-6.29 2.545a9.929 9.929 0 01-4.475-1.048 7.284 7.284 0 01-3.24-3.116c-.737-1.37-1.107-3.034-1.108-4.993zm4.627.24c0 1.69.401 2.987 1.204 3.887a3.942 3.942 0 005.936 0c.797-.902 1.195-2.208 1.195-3.92 0-1.677-.398-2.961-1.195-3.853a3.932 3.932 0 00-5.936 0c-.801.899-1.202 2.194-1.204 3.885zM67.74 26.47h-5.173l-2.055-5.349h-9.415l-1.944 5.35h-5.032l9.172-23.548h5.032L67.74 26.47zm-8.754-9.316L55.74 8.425l-3.181 8.729h6.427zM81.457 26.47v-2.554a6.554 6.554 0 01-2.45 2.154 6.9 6.9 0 01-3.203.786 6.29 6.29 0 01-3.084-.755 4.48 4.48 0 01-1.978-2.12c-.407-.91-.61-2.168-.61-3.774V9.413h4.514v7.837c0 2.4.084 3.867.25 4.404.15.518.47.97.908 1.285.494.333 1.082.5 1.677.474.74.01 1.465-.21 2.074-.629a3.211 3.211 0 001.258-1.575c.216-.625.327-2.162.334-4.613V9.413h4.514V26.47h-4.204zM98.148 9.413v3.598h-3.085v6.873c0 1.398.03 2.21.088 2.434.062.233.205.435.403.57.224.155.491.234.763.225a5.793 5.793 0 001.814-.434l.386 3.502a8.982 8.982 0 01-3.565.675 5.731 5.731 0 01-2.2-.42 3.221 3.221 0 01-1.438-1.06 4.212 4.212 0 01-.629-1.76c-.096-.524-.145-1.583-.145-3.178V13.01h-2.073V9.413h2.073v-3.39l4.523-2.63v6.02h3.085zM100.228 17.701a9.249 9.249 0 011.107-4.355 7.631 7.631 0 013.145-3.212 9.31 9.31 0 014.538-1.107c2.581 0 4.696.839 6.345 2.516 1.648 1.678 2.474 3.794 2.478 6.35 0 2.578-.832 4.718-2.497 6.418-1.665 1.7-3.762 2.548-6.291 2.545a9.924 9.924 0 01-4.474-1.065 7.289 7.289 0 01-3.236-3.114c-.743-1.359-1.115-3.017-1.115-4.976zm4.625.24c0 1.69.402 2.987 1.206 3.887a3.93 3.93 0 002.967 1.35 3.939 3.939 0 002.967-1.35c.801-.902 1.2-2.208 1.197-3.92 0-1.677-.399-2.961-1.197-3.853a3.932 3.932 0 00-5.934-.006c-.797.899-1.196 2.194-1.197 3.885l-.009.006zM124.748 26.47l-5.622-23.547h4.867l3.55 16.175 4.305-16.175h5.661l4.129 16.447 3.608-16.447h4.787l-5.72 23.547h-5.032L134.59 8.857l-4.673 17.613h-5.169zM155.793 14.617l-4.091-.74c.462-1.648 1.254-2.869 2.378-3.661 1.124-.793 2.794-1.19 5.012-1.19 2.012 0 3.512.24 4.497.716.986.476 1.679 1.081 2.08 1.813.406.734.608 2.081.608 4.041l-.048 5.27c-.027 1.11.043 2.219.21 3.317.174.793.446 1.561.811 2.287h-4.466a17.69 17.69 0 01-.434-1.331 7.888 7.888 0 00-.159-.53 8.225 8.225 0 01-2.475 1.677 7.108 7.108 0 01-2.811.553c-1.753 0-3.137-.476-4.152-1.43a4.774 4.774 0 01-1.149-1.644 4.732 4.732 0 01-.369-1.969 4.847 4.847 0 01.692-2.579 4.488 4.488 0 011.935-1.734c.83-.402 2.027-.752 3.59-1.048 2.109-.389 3.571-.752 4.386-1.09v-.458c0-.868-.214-1.486-.641-1.855-.428-.37-1.237-.553-2.426-.552-.804 0-1.433.158-1.887.474-.455.316-.818.87-1.091 1.663zm6.045 3.663c-.903.277-1.82.508-2.746.692-1.259.266-2.072.53-2.458.786a1.895 1.895 0 00-.883 1.592 2.237 2.237 0 00.707 1.638 2.487 2.487 0 001.799.69 3.916 3.916 0 002.33-.804 2.834 2.834 0 001.077-1.487c.118-.385.176-1.12.176-2.201l-.002-.906zM175.044 26.47h-4.514V9.413h4.193v2.423c.717-1.144 1.363-1.9 1.936-2.264a3.563 3.563 0 011.952-.545c1.05.003 2.08.298 2.973.851l-1.401 3.936c-.761-.495-1.468-.742-2.119-.74a2.488 2.488 0 00-1.607.522c-.44.348-.785.977-1.035 1.887-.251.91-.377 2.817-.378 5.72v5.267zM187.845 26.47h-4.512V9.413h4.193v2.423c.718-1.144 1.363-1.9 1.936-2.264a3.551 3.551 0 011.952-.545 5.703 5.703 0 012.961.851l-1.388 3.936c-.762-.495-1.469-.742-2.12-.74a2.517 2.517 0 00-1.609.522c-.439.348-.784.977-1.035 1.887-.252.91-.378 2.817-.378 5.72v5.267zM199.701 14.617l-4.098-.74c.462-1.648 1.254-2.869 2.378-3.661 1.124-.793 2.794-1.19 5.012-1.19 2.017 0 3.517.24 4.499.716.983.476 1.676 1.081 2.08 1.813.402.734.602 2.081.602 4.041l-.048 5.27c0 1.498.07 2.604.21 3.317.174.793.446 1.561.811 2.287h-4.466c-.118-.302-.26-.744-.432-1.331a8.58 8.58 0 00-.162-.53 8.22 8.22 0 01-2.474 1.677 7.092 7.092 0 01-2.81.561c-1.757 0-3.141-.476-4.153-1.43a4.744 4.744 0 01-1.518-3.61 4.838 4.838 0 01.692-2.58 4.488 4.488 0 011.935-1.733c.83-.403 2.027-.752 3.59-1.049 2.109-.395 3.571-.765 4.386-1.109v-.449c0-.868-.21-1.486-.644-1.855-.434-.37-1.237-.554-2.426-.554-.802 0-1.431.158-1.887.474-.455.316-.815.87-1.077 1.665zm6.04 3.663c-.903.275-1.822.505-2.748.692-1.259.266-2.072.53-2.458.786a1.895 1.895 0 00-.883 1.592 2.237 2.237 0 00.707 1.638 2.487 2.487 0 001.799.69 3.916 3.916 0 002.33-.804 2.84 2.84 0 001.075-1.493c.118-.386.178-1.12.178-2.201v-.9zM230.14 26.47h-4.512v-8.706c0-1.84-.097-3.029-.29-3.564-.171-.51-.5-.95-.939-1.258a2.68 2.68 0 00-1.566-.45 3.615 3.615 0 00-2.097.642 3.243 3.243 0 00-1.277 1.703c-.231.706-.346 2.013-.346 3.921v7.725h-4.512V9.413h4.193v2.516c1.489-1.93 3.363-2.893 5.622-2.892a6.766 6.766 0 012.726.537 4.562 4.562 0 011.87 1.373c.424.56.726 1.203.885 1.888.191 1 .274 2.018.247 3.036l-.004 10.6zM242.543 9.413v3.598h-3.087v6.873c0 1.398.03 2.21.088 2.434.062.232.204.434.401.57.224.155.491.233.763.225.419 0 1.025-.145 1.816-.434l.386 3.502a8.993 8.993 0 01-3.565.675 5.74 5.74 0 01-2.202-.42 3.217 3.217 0 01-1.436-1.06 4.173 4.173 0 01-.629-1.76c-.096-.524-.145-1.583-.145-3.178V13.01h-2.071V9.413h2.071v-3.39l4.523-2.63v6.02h3.087zM243.539 9.413h4.801l4.081 12.11 3.984-12.11h4.673l-6.024 16.416-1.075 2.97a12.076 12.076 0 01-1.133 2.282 4.963 4.963 0 01-1.237 1.277 5.432 5.432 0 01-1.719.763 8.994 8.994 0 01-2.307.273c-.858 0-1.714-.091-2.554-.273l-.4-3.533c.629.13 1.268.2 1.91.21 1.051 0 1.828-.308 2.33-.923a6.445 6.445 0 001.157-2.355l-6.487-17.107z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F57F26",
                        fillRule: "evenodd",
                        d: "M272.854 2.327a58.996 58.996 0 0133.031.063 56.229 56.229 0 01-.354 8.78c-9.545-6.138-21.383-9.18-32.67-8.843h-.007z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F57F26",
                        d: "M301.453 23.694l.132.063c1.514-2.55 2.417-4.496 3.007-7.13-8.417-3.438-13.676-3.291-20.713-3.784 0 .008 11.08 3.202 17.574 10.851z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F57F26",
                        d: "M295.498 23.537l-1.181 1.22c-.111.122-.226.237-.337.357l-.309.316a24.443 24.443 0 01-4.403 3.515c-7.666-4.832-10.782-11.96-11.354-20.602 6.081-.574 12.967.235 18.747 1.887-9.098-5.242-21.746-4.655-24.1-4.485.149 14 5.548 23.552 16.707 29.249 4.162-2.126 7.519-4.796 10.103-8.027 0 .006-2.462-3.063-3.873-3.43z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1_265",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H305.936V35H0z"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var logo = (GoAutoWarrantyLogo);

// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx + 1 modules
var mobile = __webpack_require__(8281);
;// CONCATENATED MODULE: ./src/components/layouts/goAutoWarrantyWrapper.tsx









const Footer = dynamic_default()(()=>__webpack_require__.e(/* import() */ 60681).then(__webpack_require__.bind(__webpack_require__, 31701)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31701)
            ]
    }
});
const Modal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 84043).then(__webpack_require__.bind(__webpack_require__, 18740)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18740)
            ]
    }
});
const CloseIcon = dynamic_default()(()=>__webpack_require__.e(/* import() */ 69655).then(__webpack_require__.bind(__webpack_require__, 69655)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69655)
            ]
    }
});
const TermsAndConditions = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10761), __webpack_require__.e(14777)]).then(__webpack_require__.bind(__webpack_require__, 10761)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10761)
            ]
    }
});
const PrivacyPolicy = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57079), __webpack_require__.e(25591)]).then(__webpack_require__.bind(__webpack_require__, 57079)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57079)
            ]
    }
});
function GoAutoWarrantyWrapper({ children  }) {
    const { modal , closeModal  } = (0,useModalContext/* useModal */.d)();
    const { visitDetails: { region  } ,  } = (0,useDomainContext/* useDomainContext */.w)();
    const handleClose = ()=>{
        closeModal();
    };
    const { active: modalActive , content: modalContent  } = modal;
    const getModalContent = ()=>{
        switch(modalContent){
            case "privacy":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicy, {
                    category: "GoAutoWarranty",
                    domain: "GoAutoWarranty.com"
                });
            case "terms":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditions, {
                    category: "GoAutoWarranty",
                    domain: "GoAutoWarranty.com"
                });
            case "sideWidget":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile/* default */.Z, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap",
                        rel: "stylesheet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    fontFamily: `'Inter', sans-serif`
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header["default"], {
                        boxShadow: "1px 1px 6px 3px #ededed",
                        slogan: `TOP AUTO WARRANTY COMPANIES in ${region ? region : ""}`,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        className: "max-w-7xl mx-auto block px-4vw lg:px-4",
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                        onClose: handleClose,
                        active: modalActive,
                        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
                        backdropClosable: true,
                        modalStyles: {
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: modalContent === "sideWidget" ? "80vh" : "100%"
                        },
                        modalClassName: "h-[90vh] rounded",
                        bodyStyles: {
                            overflowY: "scroll"
                        },
                        width: 900,
                        header: modalContent === "privacy" ? "Privacy Policy" : modalContent === "terms" ? "Terms and Conditions" : modalContent === "sideWidget" ? "Contents" : undefined,
                        children: getModalContent()
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 74206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);
/* harmony import */ var _components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10621);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19255);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79961);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);








// import CloseIcon from "@components/svg/closeIcon";

function Header({ slogan , children , textColor , iconColor , backGroundColor , isLogoClickable =true , emptyIcon , boxShadow , border , phoneNumberColor , stickyStyle , hideSticky , logoClassName , useChildrenLogo , bannerStyleAsProp , className , useSecondaryLogo =false  }) {
    const { domain , blogPost , routeConfig , showFormModal , locale , defaultLocale , pageType ,  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    const { 0: headerHeight , 1: setHeaderHeight  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const header = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: bannerActive , 1: setBannerActive  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: hidePhoneNumber , 1: setHidePhoneNumber  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { query , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const bannerTextBlock = domain.textBlocks?.find((textBlock)=>textBlock.position === "banner");
    function showingBanner() {
        if (!bannerTextBlock) return false;
        if (pageType === "page-builder") {
            return !routeConfig?.config?.settings?.preHeaderText;
        }
        return true;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let prevHeight = "0";
        const observer = new ResizeObserver(([headerEntry])=>{
            if (header.current) {
                const height = headerEntry.borderBoxSize?.[0]?.blockSize.toFixed(0);
                if (height !== prevHeight) {
                    prevHeight = height;
                    setHeaderHeight(`${height}px`);
                }
            }
        });
        if (header.current) {
            observer.observe(header.current);
        }
        if (bannerTextBlock) {
            setTimeout(()=>{
                setBannerActive(true);
            }, 500);
        }
        if (sessionStorage.getItem(_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .SKIPPED_OPERATION_ID_KEY */ .UG) && asPath.includes("thank-you")) {
            setHidePhoneNumber(true);
        }
        return ()=>{
            if (header.current) {
                observer.unobserve(header.current);
            }
        };
    }, []);
    const logoFromVariantConfig = routeConfig?.templateConfig?.variantConfig?.logo;
    const logoPath = logoFromVariantConfig ?? routeConfig?.config?.settings?.logo ?? domain?.logo?.fullPath;
    const secondaryLogoPath = domain?.secondaryLogo?.fullPath ?? null;
    const callIconUnWrappedImage = routeConfig?.templateConfig?.headerAndFooter?.header?.callIconUnWrappedImage;
    const phoneNumberBlock = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "slogan items-center flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            slogan: slogan,
            textColor: textColor,
            iconColor: iconColor ?? textColor,
            emptyIcon: emptyIcon,
            phoneNumberColor: phoneNumberColor,
            stickyStyle: stickyStyle,
            hideSticky: hideSticky || showFormModal,
            iconPath: callIconUnWrappedImage
        })
    });
    const finalUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!isLogoClickable) {
            return undefined;
        }
        const homepageHref = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .getHomepageHref */ .$N)(query, locale, defaultLocale);
        if (homepageHref === undefined) {
            return undefined;
        }
        const withQueryParams = (0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start", [
            "genericRoute",
            "keyword",
            "category",
            "formTemplate",
            "tool",
            "slug",
            "data",
            "zc",
            "filters",
            "pii-token", 
        ]);
        return `${homepageHref}?${withQueryParams}`;
    }, [
        isLogoClickable,
        query
    ]);
    const variables = routeConfig?.config?.header?.variables;
    const styles = {
        backgroundColor: backGroundColor,
        boxShadow: boxShadow,
        borderBottom: border,
        ...variables ? (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_7__/* .convertToBreakpointVariables */ .Xz)(variables) : {}
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        style: styles,
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().header)} ${className}`,
        ref: header,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `ltrStyle inner py-5 lg:py-4 px-5 flex lg:max-w-7xl mx-auto  lg:px-6 items-center ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headerContainer)} `,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().logo)} ${logoClassName ? logoClassName : ""}`,
                        style: {
                            backgroundImage: `url(${useSecondaryLogo ? secondaryLogoPath : logoPath ?? ""})`,
                            width: "auto",
                            height: "auto",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            ...domain.name === "homewarranty.deals" ? {
                                maxWidth: "330px"
                            } : {}
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: finalUrl,
                            "aria-label": `${domain.name} logo`,
                            children: logoPath && !useChildrenLogo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: logoPath,
                                className: "h-auto w-full",
                                alt: `${domain.name} logo`,
                                style: {
                                    visibility: "hidden"
                                },
                                rel: "preload"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "children:w-full children:h-auto lg:children:h-10",
                                children: children
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            blogPost && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xs lg:flex hidden justify-end text-[#6b6b6b] ",
                                children: "Advertisement"
                            }),
                            !hidePhoneNumber && phoneNumberBlock
                        ]
                    }),
                    headerHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                        children: `:root {--header-height: ${headerHeight} }`
                    })
                ]
            }),
            showingBanner() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner)} ${bannerStyleAsProp ?? ""} ${bannerActive ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""}`,
                style: {
                    "--banner-background-color": domain?.config?.bannerBgColor,
                    "--banner-text-color": domain?.config?.bannerTextColor
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: bannerTextBlock?.text ?? ""
                    },
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["banner-inner"])
                })
            })
        ]
    });
}


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 79961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ extractUrl; },
/* harmony export */   "OZ": function() { return /* binding */ generateGlobalVariables; },
/* harmony export */   "XR": function() { return /* binding */ getFinalFontFamily; },
/* harmony export */   "Xz": function() { return /* binding */ convertToBreakpointVariables; },
/* harmony export */   "Z2": function() { return /* binding */ modifyCSSForElement; },
/* harmony export */   "hJ": function() { return /* binding */ minifyCSS; },
/* harmony export */   "uC": function() { return /* binding */ getFormTemplate; }
/* harmony export */ });
/* unused harmony export breakpoints */
const breakpoints = [
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
// ****** EXAMPLE INPUT ******
// variables = {
//     "titleSize": {
//         "sm": "14px",
//         "md": "16px",
//     },
//     "descriptionSize": "14px",
//     "titleColor": {
//          "sm": "red",
//          "lg": "blue",
//     },
// }
// ****** OUTPUT ******
// breakpointVariables = {
//     "--title-size-sm": "14px",
//     "--title-size-md" : "16px",
//     "--title-size-lg" : "16px",
//     "--title-size-xl" : "16px",
//     "--title-size-xxl" : "16px",
//     "--description-size-sm": "14px",
//     "--description-size-md": "14px",
//     "--description-size-lg": "14px",
//     "--description-size-xl": "14px",
//     "--description-size-xxl": "14px",
//     "--title-color-sm": "red",
//     "--title-color-md": "red",
//     "--title-color-lg": "blue",
//     "--title-color-xl": "blue",
//     "--title-color-xxl": "blue",
// }
/**
 * Convert variables object to css variables with breakpoints handled
 *
 * @param variables - variables object to convert
 * @param namespace - optional namespace to prefix variable names (e.g., "tabs", "accordion")
 */ function convertToBreakpointVariables(variables, namespace) {
    const breakpointVariables = {};
    for (const [key, value] of Object.entries(variables)){
        if (!value) continue;
        // Create variable name with optional namespace prefix
        const varName = namespace ? `${namespace}-${key}` : key;
        if (typeof value === "object") {
            const objValue = value;
            breakpoints.forEach((breakpoint, index)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = objValue[breakpoint] || objValue[breakpoints[index - 1]] || objValue[breakpoints[index - 2]] || objValue[breakpoints[index - 3]] || objValue[breakpoints[index - 4]] || objValue["sm"] || "unset";
            });
        } else {
            breakpoints.forEach((breakpoint)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = value;
            });
        }
    }
    return breakpointVariables;
}
function generateGlobalVariables(config) {
    const cssVariables = {};
    function recursiveGenerateCSSVariables(obj, prefix = "") {
        for(const key in obj){
            if (key in obj) {
                const value = obj[key];
                if (typeof value !== "string" && value !== null) {
                    recursiveGenerateCSSVariables(value, `${prefix}-${key}`);
                } else {
                    const variableName = `--${prefix}-${key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}`;
                    cssVariables[variableName] = value || "unset";
                }
            }
        }
    }
    recursiveGenerateCSSVariables(config, "global");
    return cssVariables;
}
const minifyCSS = (css)=>css.replace(/\n/g, "").replace(/\s\s+/g, " ");
function modifyCSSForElement(cssString, selector) {
    if (!cssString) return "";
    // At-rules that should have selector prepended to their inner rules
    const scopedAtRules = [
        "@media",
        "@supports",
        "@container",
        "@layer"
    ];
    // At-rules that should be kept as-is (no selector modification)
    const globalAtRules = [
        "@keyframes",
        "@-webkit-keyframes",
        "@-moz-keyframes",
        "@font-face",
        "@import",
        "@charset",
        "@namespace",
        "@page", 
    ];
    // Helper to prepend selector to simple CSS rules
    const prependSelectorToRules = (css)=>{
        const rules = css.split("}");
        return rules.map((rule)=>{
            const trimmed = rule.trim();
            if (trimmed === "") return "";
            const braceIndex = trimmed.indexOf("{");
            if (braceIndex === -1) return `${selector} ${trimmed}`;
            const selectorPart = trimmed.substring(0, braceIndex);
            const bodyPart = trimmed.substring(braceIndex);
            const scopedSelectors = selectorPart.split(",").map((s)=>`${selector} ${s.trim()}`).join(", ");
            return `${scopedSelectors} ${bodyPart}`;
        }).join("\n}\n");
    };
    // Find the closing brace that matches an opening brace (handles nesting)
    const findMatchingBrace = (str, startPos)=>{
        let braceCount = 1;
        let pos = startPos;
        while(braceCount > 0 && pos < str.length){
            if (str[pos] === "{") braceCount++;
            if (str[pos] === "}") braceCount--;
            pos++;
        }
        return pos;
    };
    // Find the next at-rule in the string
    const findNextAtRule = (str)=>{
        const allAtRules = [
            ...scopedAtRules,
            ...globalAtRules
        ];
        let earliest = null;
        for (const atRule of allAtRules){
            const index = str.indexOf(atRule);
            if (index !== -1 && (earliest === null || index < earliest.index)) {
                earliest = {
                    index,
                    type: atRule,
                    isScoped: scopedAtRules.includes(atRule)
                };
            }
        }
        return earliest;
    };
    // Recursively process CSS (handles nested at-rules)
    const processCSS = (css)=>{
        let result = "";
        let remaining = css;
        while(remaining.length > 0){
            const nextAtRule = findNextAtRule(remaining);
            if (!nextAtRule) {
                // No more at-rules, process remaining as regular rules
                result += prependSelectorToRules(remaining);
                break;
            }
            // Process any rules before this at-rule
            if (nextAtRule.index > 0) {
                const beforeAtRule = remaining.substring(0, nextAtRule.index);
                result += prependSelectorToRules(beforeAtRule);
            }
            // Find the opening brace for this at-rule
            const openBrace = remaining.indexOf("{", nextAtRule.index);
            if (openBrace === -1) {
                // No brace found (e.g., @import or @charset statement)
                const semicolon = remaining.indexOf(";", nextAtRule.index);
                if (semicolon !== -1) {
                    result += remaining.substring(nextAtRule.index, semicolon + 1);
                    remaining = remaining.substring(semicolon + 1);
                    continue;
                }
                break;
            }
            const atRuleHeader = remaining.substring(nextAtRule.index, openBrace).trim();
            const closeBrace = findMatchingBrace(remaining, openBrace + 1);
            const atRuleContent = remaining.substring(openBrace + 1, closeBrace - 1);
            if (nextAtRule.isScoped) {
                // Scoped at-rules: process inner content recursively
                const processedContent = processCSS(atRuleContent);
                result += `\n${atRuleHeader} {\n${processedContent}\n}\n`;
            } else {
                // Global at-rules: keep content as-is
                result += `\n${atRuleHeader} {\n${atRuleContent}\n}\n`;
            }
            remaining = remaining.substring(closeBrace);
        }
        return result;
    };
    return minifyCSS(processCSS(cssString));
}
const extractUrl = (input)=>{
    const match = input.match(/^url\((.+)\)$/);
    return match ? match[1] : "";
};
const getFormTemplate = (path)=>{
    if (path.includes("/free-consultation/v1")) {
        return "v1";
    }
    if (path.includes("/free-consultation/v2")) {
        return "v2";
    }
    return null;
};
const getFinalFontFamily = (routeConfig, locale, fontFamily)=>{
    const templateGlobalConfig = routeConfig?.templateConfig;
    const fontFamilyFromOtherLanguages = templateGlobalConfig?.variantConfig?.otherLanguagesConfig?.[locale]?.fontFamily;
    const fontFamilyFromMainLanguage = templateGlobalConfig?.theme?.fontFamily?.replace(" ", "");
    if (templateGlobalConfig) {
        return fontFamilyFromOtherLanguages || fontFamilyFromMainLanguage || (locale === "ar" ? "Almarai" : "Poppins");
    } else {
        return fontFamily || (locale === "ar" ? "Almarai" : "Poppins");
    }
};


/***/ }),

/***/ 19255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__NnJo8","headerContainer":"style_headerContainer__bfY8J","logo":"style_logo__oPgVZ","banner":"style_banner__nKv8j","close-button":"style_close-button__1RZQB","active":"style_active__DfBCW","banner-inner":"style_banner-inner__pvqcg","preHeader":"style_preHeader__0jNK7"};

/***/ })

}]);